
import { TextoEditavel } from '@/dominio/editor/questoes/comum/texto/TextoEditavel';
import { defineComponent } from 'vue';
import TextoEdicao from './TextoEdicao.vue';

export default defineComponent({
    name: 'AdicionarTexto',
    components: {
        TextoEdicao,
    },
    props: {
        indice: { type: Number, required: true },
    },
    data() {
        return {
            emEdicao: false,
        };
    },
    methods: {
        editar() {
            this.emEdicao = true;
        },
        adicionarItem(item: TextoEditavel) {
            this.emEdicao = false;
            this.$emit('adicionarItem', item);
        },
        cancelou() {
            this.emEdicao = false;
        },
    },
    emits: ['adicionarItem'],
});
